import CSVColumnsStrategy from '../CSVColumnsStrategy'

export default function StaffPerformanceCSVPreviewBaseColumnsStrategy() {}

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype = Object.create(CSVColumnsStrategy.prototype)

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.init = function(includeOtherUsersColumn) {
    CSVColumnsStrategy.prototype.init.call(this)
    this.includeOtherUsersColumn = includeOtherUsersColumn
    return this
}

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addMainHeaderRowCells = function(mainHeaderRow) {
    this.addCell(mainHeaderRow, this.message("report.spent_time"))
}

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function(colGroupingRow) {
    this.addCell(colGroupingRow, "") // above Spent Sum
}

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addDataCells = function(row) {
    for (let i = 0; i < this.getNumOfDataColumns(); i++) {
        this.addTimeValueCell(row)
    }
}

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addEmptyCells = function(row) {
    ReportPreviewUtils.addEmptyCells(row, this.getNumOfDataColumns())
}

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.getNumOfDataColumns = function() {
    //abstract
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewBaseColumnsStrategy.js